define(()=> {
    return ['$rootScope', 'NavigationService', ($rootScope, NavigationService)=> {
        $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams)=> {
            NavigationService.updateHistory(toState, toParams, fromState, fromParams);
        });
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/navigation/NavigationListener.js
 **/